
import {CamToCamBase} from "./cam2cam-base";
import {WebRtcPublisher} from "../publisher/webrtc-publisher";
import {Status} from "./cam2cam";
import logging from "../utils/log";

export class CamToCamWebRTC extends CamToCamBase
{
	protected SAFE_CAM_SWITCH = false;
	protected TAG = "[Sxc.Chat.CamToCamW]";

	protected publisher : WebRtcPublisher;

	show(): Promise<any>
	{
		logging.log(this.TAG, "show...");
		this.publisher = new WebRtcPublisher(this.$root.find(".sxccc-publisher"));

		this.publisher.init();

		return new Promise((resolve, reject) =>
		{
			logging.log(this.TAG, "publisher initialized");
			this.setStatus(Status.approve);

			let askTime = Date.now();

			this.$root.find(".sxccc-publisher.sxcccp-webrtc")
				.addClass("sxc-visible");

			this.publisher.askForCam().then(() =>
				{
					if (this.publisher.getCamList().length === 0)
					{
						logging.log(this.TAG, "publisher.initialze", "No camera available");
						this.leave();
						reject("camRequired");
						return;
					}

					logging.log(this.TAG, "cam access granted");
					this.setStatus(Status.camApproved);
					resolve();
					this.prepareSettings();
					this.publish();
				}
			).catch((e) =>
			{
				logging.log(this.TAG, "askForCam failed", e);
				this.leave();
				if (e.name && e.name === "PermissionDismissedError") {
					reject("ignored");
				} else if (e.name && e.name === "NotAllowedError") {
					if ((Date.now() - askTime < 1000)) {
						reject("alreadyBlocked");
					} else {
						reject("blocked");
					}
				} else {
					reject("technical");
				}
			});
		});
	}

	publish()
	{
		logging.log(this.TAG, "publish...");

		this.setStatus(Status.prepareStream);
		this.publisher.showPreview(true);


		const stream = this.app.chatServer.getWebRtcCamInfo();

		logging.log(this.TAG, "publish, stream data", stream);

		this.mute(this.muted);
		this.stream = stream;

		this.publisher.publish(this.stream, this.cam, this.mic).then(() => {
			logging.log(this.TAG, "publishing");
			this.setStatus(Status.streaming);

			setTimeout(() => {
				this.app.chatServer.startCamToCam("webrtc").then(() => {
					this.snapshots.init(this.publisher);
				}).catch((reason) => {
					logging.log(this.TAG, "publish, startCam2Cam failed:", reason);
					this.leave();
				});

			}, 2000)

		}).catch(() => {
			logging.error(this.TAG, "publish, connect failed");
			this.leave();
		})

		// this.app.chatServer.startCamToCam("webrtc").then((stream) =>
		// {
		// 	logging.log(this.TAG, "publish, stream data", stream);
		//
		// 	this.mute(this.muted);
		// 	this.stream = stream;
		//
		// 	this.publisher.publish(this.stream, this.cam, this.mic).then(() => {
		// 		logging.log(this.TAG, "publishing");
		// 		this.setStatus(Status.streaming);
		// 		this.snapshots.init(this.publisher);
		//
		// 	}).catch(() => {
		// 		logging.error(this.TAG, "publish, connect failed");
		// 		this.leave();
		// 	})
		//
		// }).catch((reason) => {
		// 	logging.log(this.TAG, "publish, startCam2Cam failed:", reason);
		// 	this.leave();
		// });
	}
}
